import { getShortDomain } from './getShortDomain.js';
const removeCookie = ({ name, currentDomainOnly = false }) => {
    const expires = "expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    const path = "path=/;";
    document.cookie = `${name}=;${path}${expires}`;
    if (!currentDomainOnly) {
        document.cookie = `${name}=;${path}${expires} domain=${getShortDomain()};`;
    }
};
export { removeCookie };
